import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import CoolCats from '../../../api/contract'
import { numSpaces, sleep } from '../../../utils/functions'
import { pushNotification } from '../../../store/notifications/thunks'

import { DropdownButton } from './DropdownButton/DropdownButton'
import { ProgressBar } from '../../../components/ProgressBar/ProgressBar'
import { Button } from '../../../components/Button/Button'
import { Preloader } from '../../../components/Preloader/Preloader'

import pool from '../../../assets/img/cats_pool.PNG'

import './WalletInfo.scss'

export const WalletInfo = ({ total, max, wallet }) => {
	const dispatch = useDispatch()
	const [catsCount, setCatsCount] = useState(1)
	const [contract, setContract] = useState(null)
	const [isLoading, setIsLoading] = useState(false)

	useEffect(() => {
		let isMount = true
		const initTimer = setInterval(() => {
			if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
				clearInterval(initTimer)
				new CoolCats()
					.init(window.tronWeb)
					.then((c) => {
						if (isMount) setContract(c)
					})
					.catch(console.log)
			}
		}, 500)

		return () => (isMount = false)
	}, [setContract])

	const mint = () => {
		window.gtag('event', 'conversion', {
			'send_to': 'AW-970914587/6wVJCJrFhPYCEJv2-84D',
			'transaction_id': '',
			'event_callback': () => {}
		})

		setIsLoading(true)
		sleep(1000)
			.then(() => {
				dispatch(pushNotification({
					id: Date.now(),
					type: 'common',
					msg: 'TRX 进行中',
				})) 
				setIsLoading(false)

				return contract.mint(catsCount)
			})
			.then((nfts) => {
				if (nfts.length)
					window.gtag('event', 'conversion', {
						'send_to': 'AW-970914587/QmsWCJy_ovYCEJv2-84D',
						'transaction_id': ''
					});

				dispatch(
					pushNotification(
						nfts.length
						? {
								id: Date.now(),
								type: 'success',
								msg: '支付成功！',
						  }
						: {
								id: Date.now(),
								type: 'error',
								msg: '余额不足',
						  },
					)
				)
			})
			.catch((e) => {
				console.log(e)
				dispatch(
					pushNotification({
					id: Date.now(),
					type: 'error',
					msg: '传输错误',
				}))
			})
	}

	return contract
		?	(
			<div className="wallet-info">
				<div className="title-container">
					<h1 className="page-title">造币成本 1500 TRX</h1>
					<p className="page-subtitle">想领养一只小猫？</p>
				</div>
				<div className="buttons-container">
					<DropdownButton
						listItems={[
							{
								value: 1,
								label: 'x 1',
							},
							{
								value: 5,
								label: 'x 5',
							},
							{
								value: 10,
								label: 'x 10',
							},
							{
								value: 15,
								label: 'x 15',
							},
						]}
						selectedLabel={`${catsCount} x TRON一只酷猫`}
						onChange={setCatsCount}
					/>
					<Button
						label={isLoading ? '加载' : '开始铸造'}
						color="red"
						large
						disabled={isLoading}
						onClick={mint}
					/>
					<span className="label">还剩 {numSpaces(max - total)} 只酷猫</span>
				</div>
				<div className="info-container">
					<div className="stats-container">
						<div className="row">
							<span className="stat-label">最大限制</span>
							<div className="dotted-line"></div>
							<span className="stat-label">{numSpaces(max)}</span>
						</div>
						<div className="row">
							<span className="stat-label">您的余额</span>
							<div className="dotted-line"></div>
							<span className="stat-label">{numSpaces(wallet.balance)} TRX</span>
						</div>
					</div>
					<ProgressBar percent={(total / max) * 100} />
				</div>
				<div className="text-container">
					<div className="picture">
						<img src={pool} alt="猫 pool" />
					</div>
					<div className="text main">
						<h1>
							大酷猫一家是幸福的一家！
						</h1>
					</div>
					<div className="text second">
						<p>
							铸造 31+ 猫 -获得3% Pool
							<br />
							铸造 151+ 猫 -获得7% Pool
						</p>
					</div>
				</div>
			</div>
		)
		: <Preloader />
}
